module.exports = __webpack_public_path__ + "static/media/play-store-fr.89a71594.svg";